export default "__VITE_ASSET__81671384__"